export const ONE_TRUST_COOKIE_ROUTE_BLACKLIST = [
  '/data-protection'
]
